import {
  closeDateCalendar,
  dateCalendar,
  dateCalendarKey,
} from "../components/date-picker.js";

export function installCalendarEvents() {
  document.addEventListener("keydown", dateCalendarKey);

  window.addEventListener("resize", () => closeDateCalendar());

  window.addEventListener(
    "scroll",
    (ev) => {
      if (
        dateCalendar &&
        !document.getElementById("date-calendar")?.contains(ev.target)
      )
        closeDateCalendar();
    },
    { capture: true, passive: true },
  );
}
